import { observer } from 'mobx-react-lite';
import { useTranslationsContext } from 'store/translations';

import TripleCollection from '../assets/img/full_collection.png';
import Ticket from '../assets/img/ticket_bg.png';

import './welcomePage.styl';
import { Button } from 'components/core';
import { useNavigate } from 'react-router';
import { UIEventHandler, useCallback, useEffect, useLayoutEffect, useState } from 'react';
import { useStoreContext } from 'store/app';
import { routes } from 'utils/router';

export const WelcomePage = observer(() => {
    const { translate } = useTranslationsContext();
    const { isAnonym, logOperation, openLink, linkToRules } = useStoreContext();
    const [isTopBlurVisible, setIsTopBlurVisible] = useState(false);
    const [isBottomBlurVisible, setIsBottomBlurVisible] = useState(false);
    const navigate = useNavigate();
    const [scrollerRef, setScrollerRef] = useState<HTMLDivElement | null>();

    const onSubmit = () => {
        logOperation(isAnonym ? 'anonym_rules' : 'onboard', 'start');
        navigate(routes.lootbox, { state: { isWelcomeFlow: true } });
    };

    const onRulesClick = () => {
        logOperation('onboard', 'rules');
        openLink(linkToRules, true);
    };

    useEffect(() => {
        logOperation(isAnonym ? 'anonym' : 'onboard', 'render');
    }, []);

    const checkBlurState = useCallback(() => {
        if (!scrollerRef) return;

        const { scrollTop, scrollHeight, offsetHeight } = scrollerRef;
        setIsTopBlurVisible(scrollTop > 2);
        setIsBottomBlurVisible(Math.abs(scrollHeight - offsetHeight - scrollTop) > 2);
    }, [scrollerRef]);

    useLayoutEffect(() => {
        checkBlurState();
    }, [checkBlurState]);

    const onScroll: UIEventHandler<HTMLDivElement> = useCallback(() => {
        checkBlurState();
    }, [checkBlurState]);

    return (
        <div className="welcome-page">
            <div className="welcome-page-title">{translate('welcome.title')}</div>
            <div className="welcome-page-content-wrapper">
                <div className="welcome-page-content" onScroll={onScroll} ref={setScrollerRef}>
                    <div className="welcome-page-desc">{translate('welcome.desc')}</div>
                    <div className="welcome-page-cards">
                        <div className="welcome-page-card collect">
                            <img src={TripleCollection} className="welcome-page-card-image collect" />
                            <div className="welcome-page-card-text collect">{translate('welcome.card.collection')}</div>
                        </div>
                        <div className="welcome-page-card ticket">
                            <img src={Ticket} className="welcome-page-card-image ticket" />
                            <div className="welcome-page-card-text ticket">{translate('welcome.card.ticket')}</div>
                        </div>
                    </div>
                </div>
                <div className="welcome-page-content-top-blur" style={{ opacity: isTopBlurVisible ? 1 : 0 }} />
                <div className="welcome-page-content-bottom-blur" style={{ opacity: isBottomBlurVisible ? 1 : 0 }} />
            </div>
            <div className="welcome-page-bottom">
                <Button className="welcome-page-button orange" onClick={onSubmit}>
                    {translate('welcome.submit')}
                </Button>
                {!isAnonym ? (
                    <div className="welcome-page-rules">
                        {translate('welcome.rules.part1')}
                        <span onClick={onRulesClick}>{translate('welcome.rules.part2')}</span>
                    </div>
                ) : null}
            </div>
        </div>
    );
});
